const Payments = {
  types: {
    ONE_TIME: "one_time",
    SUBSCRIPTION: "subscription",
  },
  paymentMethodTypes: {
    ACH: "ach",
    CARD: "ccd",
    CHECK: "check",
    OFFLINE: "offline"
  },
  paymentMethodTypeEmpty: 'none'
}

export default Payments;
